import React, { useContext, useState } from 'react';
import { View } from 'react-native';
import { Button, Icon, Input, Text } from '@rneui/themed';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import Styles from './styles';
import Loading from '../../Loading';
import { post } from '../../../../common/Api';
import Utils from '../../../../common/Utils';
import AppContext from '../../../../contexts/App';
import LayoutContext from '../../../../contexts/Layout';
import RegistrationContext, { Actions } from '../../../../contexts/Registration';

const RegistrationStep1 = ({ control, getValues, isValid, setError }) => {
    const { state } = useContext(AppContext);
    const { dispatch } = useContext(RegistrationContext);
    const { layout } = useContext(LayoutContext);
    const [confirming, setConfirming] = useState(false);

    const handleConfirmAndVerifyEmail = async () => {
        const emailAddress = getValues('email');

        if (emailAddress) {
            setConfirming(current => !current);

            let endpoint = `${state.settings.openIdSettings.authority}/Account/ValidateEmailAddressIsAvailableAndNotGei`;
            let response = await post(endpoint, { email: emailAddress });

            if (response?.valid) {
                endpoint = `${state.settings.openIdSettings.authority}/Account/SendVerificationEmail`;
                response = await post(endpoint, { email: emailAddress, domain: state.settings.websiteSettings.domain });

                if (response?.success) {
                    dispatch({
                        type: Actions.SET_EMAIL_CONFIRM_ID,
                        emailConfirmationCodeId: response.confirmationCodeId,
                        resendCode: false
                    });
                } else {
                    setError('email', {
                        type: 'custom',
                        message: 'Unable to confirm your email address. Please check your code and try again.'
                    });
                }
            } else {
                setError('email', {
                    type: 'custom',
                    message: 'Unable to verify your email address. Please check and try again.'
                });
            }
        }

        setConfirming(_ => false);
    };

    return (
        <View style={{ width: '100%' }} testID='Registration.Step1'>
            <View style={{ flexDirection: 'row', marginHorizontal: layout.styleGuide.gutter }}>
                <Text style={Styles.introductionText}>Please provide some information so that we can get your account setup.</Text>
            </View>
            <View
                style={{
                    flexDirection: layout.device.isMobile ? 'column' : 'row',
                    justifyContent: 'space-around',
                    marginHorizontal: layout.styleGuide.spacer1,
                    marginTop: 20
                }}
            >
                <View style={{ marginBottom: layout.device.isMobile ? 20 : 0 }}>
                    <Icon color={'#8897a2'} containerStyle={{ overflow: 'visible' }} name='user-circle' size={layout.device.isMobile ? 50 : 100} type='font-awesome-5' />
                    <Text style={Styles.introductionIconText}>24/7 Access to Account Information</Text>
                </View>
                <View>
                    <Icon color={'#8897a2'} containerStyle={{ overflow: 'visible' }} name='shopping-cart' size={layout.device.isMobile ? 50 : 100} type='font-awesome-5' />
                    <Text style={Styles.introductionIconText}>View Contribution & Purchase History</Text>
                </View>
            </View>
            <View style={{ flexDirection: 'row', width: '100%' }}>
                <Controller
                    control={control}
                    defaultValue=''
                    name='email'
                    render={({ field, fieldState }) => {
                        return (
                            <Input
                                {...field}
                                containerStyle={{ width: '100%', marginLeft: 10, marginVertical: 10 }}
                                errorMessage={!fieldState.error ? 'EMAIL ADDRESS' : fieldState.error?.message}
                                errorStyle={!fieldState.error ? Styles.placeholderStyle : Styles.errorStyle}
                                innerRef={field.ref}
                                inputStyle={Styles.smallInputStyle}
                                onChangeText={val => field.onChange(val)}
                                textContentType='emailAddress'
                                spellCheck={false}
                            />
                        );
                    }}
                    rules={{
                        required: {
                            message: 'Email is required',
                            value: true
                        },
                        pattern: {
                            message: 'Not a valid email address',
                            value: Utils.ValidEmailRegExp
                        }
                    }}
                />
            </View>
            <Button
                buttonStyle={Styles.stepButton}
                containerStyle={Styles.stepButtonContainer}
                disabled={!isValid}
                disabledStyle={Styles.disabledStepButton}
                disabledTitleStyle={Styles.disabledStepButtonTitle}
                onPress={() => handleConfirmAndVerifyEmail()}
                title='NEXT STEP'
                titleStyle={Styles.stepButtonTitle}
                type='solid'
            />
            {confirming && <Loading />}
        </View>
    );
};

RegistrationStep1.propTypes = {
    control: PropTypes.object.isRequired,
    getValues: PropTypes.func.isRequired,
    isValid: PropTypes.bool.isRequired,
    setError: PropTypes.func.isRequired
};

export default RegistrationStep1;
